// extracted by mini-css-extract-plugin
export default {"general":"promotions_general__SMTLu","furnitureContainer":"promotions_furnitureContainer__lCsw5"};